namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_code_sql, {

		// Codes: {
		// 	flex: {
		// 		grow: 1,
		// 	},
		// },
		
		Textarea_sql: {
			pointerEvents: 'none',
			Edit: {
				pointerEvents: 'auto',
			},
			padding: {
				left: $mol_gap.block,
			},
			margin: $mol_gap.block,
			View: {
				Copy: {
					position: 'absolute',
					left: '-1rem',
				},
			},
		},
		
	} )
	
}
